import HeaderBgImg from 'images/subcontracting/HeaderBg.webp';

export const HeaderBg = (HeaderBgImg as any).src || HeaderBgImg;